var _path, _path2, _path3, _path4, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_752_4391",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 18,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3251 15.6292H7.19596L5.24805 7.83752H19.273L17.3251 15.6292Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30005 5.5H4.66359L5.24797 7.8375M5.24797 7.8375L7.19588 15.6292H17.325L19.273 7.8375H5.24797Z",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19585 19.525C7.84133 19.525 8.3646 19.0017 8.3646 18.3563C8.3646 17.7108 7.84133 17.1875 7.19585 17.1875C6.55037 17.1875 6.0271 17.7108 6.0271 18.3563C6.0271 19.0017 6.55037 19.525 7.19585 19.525Z",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.325 19.525C17.9705 19.525 18.4938 19.0017 18.4938 18.3563C18.4938 17.7108 17.9705 17.1875 17.325 17.1875C16.6795 17.1875 16.1562 17.7108 16.1562 18.3563C16.1562 19.0017 16.6795 19.525 17.325 19.525Z",
    stroke: "white",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_752_4391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13135 3.16248H20.8313V21.8625H2.13135V3.16248Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.34f394a9.svg";
export { ForwardRef as ReactComponent };